import type { ApiError as ApiErrorBody } from "@cs2/contracts/transport";
import { ApiError } from "./ApiError.js";

export async function request(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const response = await fetch(input, { credentials: "same-origin", ...init });
  if (response.ok) return response;
  const body = (await response
    .json()
    .catch(() => ({ message: response.statusText }))) as Partial<ApiErrorBody>;
  throw new ApiError(
    response.status,
    body.code ?? "INTERNAL_ERROR",
    body.message ?? `HTTP ${response.status}`,
    Array.isArray(body.details) ? body.details : undefined,
    body.current,
  );
}
